export default __webpack_public_path__ + "src/appV2/redesign/ConcordeScholarship/assets/images/graduationCap.png";